import { assertCan, can, CAPABILITY } from "./permissions";

export function requireProjectFinancialView(actor) {
  assertCan(actor, CAPABILITY.PROJECT_DETAIL_FINANCIAL);
}

export function requireFinancialMetricsView(actor) {
  assertCan(actor, CAPABILITY.FINANCIAL_MARGIN_VIEW);
}

export function requireEstimateView(actor) {
  assertCan(actor, CAPABILITY.ESTIMATE_VIEW);
}

export function requireEstimateEdit(actor) {
  assertCan(actor, CAPABILITY.ESTIMATE_EDIT);
}

export function requireEstimateApprove(actor) {
  assertCan(actor, CAPABILITY.ESTIMATE_APPROVE);
}

export function requireEstimateConvert(actor) {
  assertCan(actor, CAPABILITY.ESTIMATE_CONVERT);
}

export function requireInvoiceView(actor) {
  assertCan(actor, CAPABILITY.INVOICE_VIEW);
}

export function requireInvoiceReview(actor) {
  assertCan(actor, CAPABILITY.INVOICE_REVIEW);
}

export function requireInvoiceSend(actor) {
  assertCan(actor, CAPABILITY.INVOICE_SEND);
}

export function requireInvoiceMarkPaid(actor) {
  assertCan(actor, CAPABILITY.INVOICE_MARK_PAID);
}

export function requireMaterialUsageManual(actor) {
  assertCan(actor, CAPABILITY.MATERIAL_USAGE_MANUAL);
}

/**
 * Project Detail operational material entry.
 * Managers use material.usage.manual. Employees who can commit session
 * materials may record quantity against a project they can open.
 * Void and pricing stay on the manager capabilities.
 */
export function requireProjectOperationalMaterialCommit(actor) {
  if (
    can(actor, CAPABILITY.MATERIAL_USAGE_MANUAL) ||
    can(actor, CAPABILITY.SESSION_MATERIALS_COMMIT)
  ) {
    return;
  }

  assertCan(actor, CAPABILITY.MATERIAL_USAGE_MANUAL);
}

export function requireMaterialUsageVoid(actor) {
  assertCan(actor, CAPABILITY.MATERIAL_USAGE_VOID);
}

export function requireAccountsPayableView(actor) {
  assertCan(actor, CAPABILITY.ACCOUNTS_PAYABLE_VIEW);
}

export function requireAccountsReceivableView(actor) {
  assertCan(actor, CAPABILITY.ACCOUNTS_RECEIVABLE_VIEW);
}

/** Client statements use the same gate as Accounts Receivable. */
export function requireClientStatementView(actor) {
  requireAccountsReceivableView(actor);
}
